import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ServicesContent from "./Components/ServiceContent";
import Testimonial from "./Components/Testimonial";
import Smdisplay from "./Components/SMdisplay";
import Offer from "./Components/Offer";
import ServiceSecond from "./Components/ServiceSecond";
import Loader from "./Components/Loader";
import ServiceContent1 from "./Components/ServiceContent1";
import ServiceSecond2 from "./Components/ServiceSecond2";

const ServicePage=()=>{
     const { title } = useParams();

       useEffect(()=>{
                     document.title="Service | Balaji Badminton Academy"
                   },[]);
    return(
        <>
            <Header/>
            <Loader/>
            {/* <ServicesContent /> */}
            <ServiceContent1 title={title}/>
            {/* <ServiceSecond/> */}
            <ServiceSecond2 title={title}/>
            <Testimonial/>
            <Smdisplay/>
            <Footer/>
        </>
    );
}

export default ServicePage;